import { useState, useEffect, useRef, useCallback } from "react";
import { API_BASE } from "../utils/draftutils";
import SceltaComuni from "../components/sceltacomuni";

export default function CreaComprensorio() {
  const topRef = useRef(null);
  const [fase, setFase] = useState(1); 
  const [nome, setNome] = useState("");
  const [comuni, setComuni] = useState([]);
  const [selezionati, setSelezionati] = useState([]);
  const [messaggio, setMessaggio] = useState("");
  const [loading, setLoading] = useState(false);

  const scrollToTop = useCallback(() => {
    topRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  }, []);

  // Carica i comuni SOLO quando entri in fase 2
  useEffect(() => {
    if (fase === 2 && comuni.length === 0) {
      fetch(`${API_BASE}/api/comuni`)
        .then((res) => res.json())
        .then((data) => {
          const sorted = [...data].sort((a, b) => a.localeCompare(b));
          setComuni(sorted);
        })
        .catch((err) => console.error(err));
    }
  }, [fase, comuni.length]);

  useEffect(() => {
    if (messaggio) scrollToTop();
  }, [messaggio, scrollToTop]);

  // Step 1: verifica dal backend se il nome esiste
  const handleVerifica = async () => {
    if (!nome.trim()) return setMessaggio("Inserisci un nome per il comprensorio.");

    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/comprensori/check?nome=${encodeURIComponent(nome)}`
      );
      const { exists } = await res.json();

      if (exists) {
        setMessaggio("Il nome del comprensorio esiste già.");
      } else {
        setMessaggio("");
        setFase(2);
      }
    } catch (err) {
      setMessaggio("Errore di rete: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Step 2: invio dati con i comuni selezionati
  const handleSalvaComprensorio = async () => {
 
    try {    
      if (selezionati.length === 0) {
        setMessaggio("Seleziona almeno un comune.");
        return;
      }
      const response = await fetch(`${API_BASE}/api/comprensori`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nome, comuni: selezionati }),
      });

      if (response.ok) {
        const text = await response.text();
        setMessaggio(text);
        setNome("");
        setSelezionati([]);
        setFase(1);
      } else {
        const err = await response.text();
        setMessaggio("Errore: " + err);
      }
    } catch (error) {
      setMessaggio("Errore di rete: " + error.message);
    }
  };

  return (
    <div className="p-4 max-w-lg mx-auto" ref={topRef}>
      <h2 className="text-xl mb-4 font-bold">CREA COMPRENSORIO</h2>

      {messaggio && (
        <div
          className={`alert ${
            messaggio.includes("successo") ? "alert-info" : "alert-danger"
          } d-inline-block`}
          role="alert"
          style={{ maxWidth: "500px" }}
        >
          {messaggio}
        </div>
      )}

      <hr className="my-4" />

      {/* Fase 1: inserimento nome */}
      {fase === 1 && (
        <div>
          <label className="block mb-2">
            Inserisci il nome del Comprensorio geografico:&nbsp;&nbsp;&nbsp;&nbsp;
            <input
              type="text"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              className="border p-2 w-full mt-1"
            />
          </label>

          <button
            type="button"
            onClick={handleVerifica}
            className="btn btn-success ms-3"
            disabled={loading}
          >
            {loading ? "Verifica in corso..." : "Verifica e Crea"}
          </button>
        </div>
      )}

      {/* Fase 2: selezione comuni */}
      {fase === 2 && (
        <SceltaComuni
          nome={nome}
          comuni={comuni}
          selezionati={selezionati}
          setSelezionati={setSelezionati}
          onSalva={handleSalvaComprensorio}
        />
      )}
    </div>
  );
}
